import AgeCommunication from '~/pages/communication/age/libs/components/AgeCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const AgeCommunicationPage = (props: TPageProps) => (
  <AgeCommunication {...props} />
)

export default AgeCommunicationPage
